import { render, staticRenderFns } from "./IsLoading.vue?vue&type=template&id=610584c5&scoped=true"
import script from "./IsLoading.vue?vue&type=script&lang=ts"
export * from "./IsLoading.vue?vue&type=script&lang=ts"
import style0 from "./IsLoading.vue?vue&type=style&index=0&id=610584c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610584c5",
  null
  
)

export default component.exports